const TRADE_IN_PNEUMATICS_FIELDS = {
  WEAR: 'WEAR',
  ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION',
  SECOND_WEAR: 'SECOND_WEAR'
}

export default TRADE_IN_PNEUMATICS_FIELDS
